import { useMediaQuery } from "usehooks-ts"

/**
 * Returns true when viewport is below the sidebar breakpoint (md: 768px).
 * Used by shadcn Sidebar for mobile vs desktop behavior.
 */
export function useIsMobile() {
  return !useMediaQuery("(min-width: 768px)")
}
